module.exports = __webpack_public_path__ + "img/logo-light.51d2b894.svg";